import API from "../../core/apiConfig";
import { normalizePaginatedResponse } from "../../core/response";
import type { CustomerListParams, CustomerPayload } from "./types";

const getAllCustomer = async (params: CustomerListParams) => {
  const response = await API.get("/admin/customer", { params }).then(
    (res) => res.data,
  );

  if (!response.success) return response;

  return normalizePaginatedResponse(response, "current");
};

const getCustomer = async (id: string) => {
  const response = await API.get(`/admin/customer/${id}`).then(
    (res) => res.data,
  );
  return response?.success ? response.data : response;
};

const postCreateCustomer = async (payload: CustomerPayload) =>
  API.post("/admin/customer", payload).then((res) => res.data);

const putUpdateCustomer = async (payload: CustomerPayload, id: string) =>
  API.put(`/admin/customer/${id}`, payload).then((res) => res.data);

export default {
  getAllCustomer,
  getCustomer,
  postCreateCustomer,
  putUpdateCustomer,
};
